export enum PromotionSource {
  invitation = 'invitation',
  admin = 'admin',
}
